import { useEffect, useState } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { Route, Routes } from 'react-router-dom';

import NotFound from './pages/NotFound';
import Disconnected from './pages/Disconnected';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Sessions from './pages/Sessions';
import Messages from './pages/Messages';
import Resources from './pages/Resources';
import Settings from './pages/Settings';
import LinkedAccount from './pages/LinkedAccount';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import OnboardingSetup from './pages/OnboardingSetup';
import 'react-quill/dist/quill.snow.css';
import 'react-phone-number-input/style.css';
import { useAppDispatch, useAppSelector } from './Store/hooks';
import { getCoachInfo } from './Store/StudentSlices/getCoachSlice';

const App = () => {
  const [isDisconnected, setIsDisconnected] = useState(false);
  const dispatch = useAppDispatch();
  interface ErrorMessage {
    status?: number;
    response?: {
      status?: number;
      data?: { message?: string };
    };
    data?: { message?: string };
    [key: string]: any;
  }

  const { coachInfo, errorMessage, loading } = useAppSelector((state) => state.getCoach) as {
    coachInfo: any;
    errorMessage: ErrorMessage;
    loading?: boolean;
  };


  useEffect(() => {
    const handleDisconnected = () => setIsDisconnected(true);
    window.addEventListener('api-disconnected', handleDisconnected);
    return () => {
      window.removeEventListener('api-disconnected', handleDisconnected);
    };
  }, []);

  const { isLoaded, isSignedIn } = useAuth();

  // Fetch coach info when auth is ready and user is signed in
  useEffect(() => {
    if (isLoaded && isSignedIn) {
      dispatch(getCoachInfo());
    }
  }, [dispatch, isLoaded, isSignedIn]);

  // useEffect(() => {
  //   const status =
  //     errorMessage?.status 
     
  //   const isAuthError = status === 401 || status === 403;
  //   if (isAuthError) {
  //      console.log('status', status);
  //     const origin = window?.location?.href ?? '';
  //     window.location.href = `${signInRedirect}?origin=${encodeURIComponent(
  //       origin
  //     )}`;
    
  //   }
  // }, [errorMessage, signInRedirect]);

  const status = errorMessage?.status ?? errorMessage?.response?.status;
  const isAuthError = status === 401 || status === 403;
  const isUserNotFound = status === 404;
  const hasCoachData = Boolean(coachInfo);
  const isLoadingAuth = loading && !coachInfo;
  
  const shouldRedirectToLogin = !isLoadingAuth && !hasCoachData && (isAuthError || isUserNotFound);

  useEffect(() => {
    if (shouldRedirectToLogin) {
      window.location.href = process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';
    }
  }, [shouldRedirectToLogin]);

  if (isDisconnected) {
    return <Disconnected />;
  }

  if (shouldRedirectToLogin || isLoadingAuth) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-indigo-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/linked-account" element={<LinkedAccount />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/onboarding" element={<OnboardingSetup />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/home" element={<Dashboard />} />
      <Route path="/students" element={<Home />} />
      <Route path="/students/:studentId" element={<Home />} />
      <Route path="/sessions" element={<Sessions />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
